import request from '@/utils/request.js';
const api = {
  user: {
    login: (data) => {
      return request.get('/loginByName', data)
    },
    getVedioListByGroup: (data) => {
      return request.get('/app/product/vedio/getVedioListByGroup', data)
    },
  }

}
export default api


// WEBPACK FOOTER //
// ./src/api/index.js